import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';

// NgRx
import { Store } from '@ngrx/store';
import * as LogoActions from '@store/actions/logo.actions';
import * as ThemeActions from '@store/actions/theme.actions';

import { NavbarService, ThemeService } from '../../index';
import {
  AuthService,
  BussinesService,
  TokenService,
} from '../../../public/services';
import { Cookies } from 'typescript-cookie';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { HeaderComponent } from '../../components/header/header.component';
import { AccountStatusService } from '@public/services/account-status.service';
import { filter } from 'rxjs';
import { ModalIdleComponent } from '@shared/components/modal-idle/modal-idle/modal-idle.component';
import { ModalTokenComponent } from '@shared/components/modal-token/modal-token';
import { MatDialog } from '@angular/material/dialog';
import { JwtService } from '@public/services/jwt.service';
import { StateJwtService } from '@admin/services/stateJwt.service';

@Component({
  templateUrl: './layout.component.html',
  styles: [
    `
      .layout-sidebar {
        height: calc(100vh - 64px);
      }

      .layout-content {
        background-color: #f6f7ff;
        height: calc(100vh - 64px);
      }

      .footer_container {
        background-color: #4c4848;
      }
    `,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    MatSidenavModule,
    SidebarComponent,
    RouterOutlet,
    ModalIdleComponent,
    ModalTokenComponent,
  ],
})
export class LayoutComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  public isDesktop = true;
  public username: string | { [property: string]: string } | undefined;
  public opened = true;
  public mobileQuery!: MediaQueryList;
  private mobileQueryListener!: () => void;

  public themeService = inject(ThemeService);
  private tokenService = inject(TokenService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private media = inject(MediaMatcher);
  private navbarService = inject(NavbarService);
  private authService = inject(AuthService);
  private readonly store = inject(Store);

  public isShowSidebar = computed(() => this.navbarService.isShowSidebar());
  public currentUser = computed(() => this.authService.currentUser());
  private currentLogo = signal<number>(0);
  private currentTheme = signal<number>(0);

  #jwtService = inject(JwtService);
  stateServiceJWt = inject(StateJwtService);

  #accountStatusService = inject(AccountStatusService);
  private bussinesService = inject(BussinesService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  bandera = signal(true);
  banderaRecibida: boolean = false;

  constructor() {
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this.mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);

    this.navbarService.changeShow(!this.mobileQuery.matches);
    this.theme();
  }

  public currentCompany = signal(
    this.tokenService.getCompany() ?? this.tokenService.getRole()
  );

  ngOnInit(): void {
    this.validarSuspencion();
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        filter(
          (event: NavigationEnd) =>
            !event.urlAfterRedirects.includes('/public/sign-out')
        )
      )
      .subscribe(() => {
        this.validarSuspencion();
      });
    this.username = Cookies.get('username');
    const logo = this.tokenService.getLogo();
    const theme = this.tokenService.getTheme();
    if (logo !== undefined) {
      this.currentLogo.set(parseInt(logo));
    }

    if (theme !== undefined) {
      this.currentTheme.set(parseInt(theme));
    }

    this.store.dispatch(LogoActions.getLogo({ idLogo: this.currentLogo() }));
    this.store.dispatch(
      ThemeActions.getTheme({ idTheme: this.currentTheme() })
    );
    this.validarToken();
  }

  validarToken() {
    const token = this.tokenService.getToken();

    if (token) {
      this.tokenService.saveToken(token);

      const expiration = this.tokenService.getTokenExpiration();

      if (expiration) {
        const expirationDate = new Date(expiration);
        const fechaActual = new Date();
        const cincoMinutosMenos = new Date(
          expirationDate.getTime() - 5 * 60000
        );

        const diferenciaEnMilisegundos =
          cincoMinutosMenos.getTime() - fechaActual.getTime();

        //AQUI MOSTRAMOS EL MODAL.
        setTimeout(() => {
          this.stateServiceJWt.banderaActual.subscribe(
            bandera => (this.banderaRecibida = bandera)
          );
          if (this.bandera() && this.banderaRecibida) {
            this.validarModalToken();
          }
        }, diferenciaEnMilisegundos);
      } else {
        // console.log('La fecha de expiración del token es indefinida.');
      }
    }
  }

  async refreshtoken() {
    try {
      const resp = await this.#jwtService.validationLogin().toPromise();

      if (resp)
        if (resp.code === 10000) {
          const token = resp.reply;
          this.tokenService.saveToken(token);
          return true; // Devolver true si se actualizó el token con éxito
        }

      return false; // Devolver false si no se actualizó el token
    } catch (error) {
      // Manejo de errores
      console.error('Error al refrescar el token:', error);
      return false; // Devolver false en caso de error
    }
  }

  validarModalToken() {
    const dialogRef = this.dialog.open(ModalTokenComponent, {
      //Objeto del workplace
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === 'Refresh') {
        console.log('refrescar token');

        await this.refreshtoken();
        this.validarToken();
      }
      if (result === 'Cerrar') {
        this.bandera.set(false);
        console.log('Cerrar sesion');
        this.router.navigate(['/public/sign-out']);
      }
    });
    dialogRef.disableClose = true;
  }

  validarSuspencion() {
    const businessId = this.bussinesService.getBussinesId();
    if (businessId) {
      this.#accountStatusService.getStatusAccountById(businessId);
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);

    this.sidenav.close();
  }

  private theme() {
    if (!this.tokenService.getTheme()) return;

    this.themeService.setTheme(this.tokenService.getTheme());
  }
}
